module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-circle"
  }, [_c('svg', {
    attrs: {
      "width": _vm.radius,
      "height": _vm.radius,
      "viewBox": "0 0 100 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "progress-background",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress-bar",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent",
      "stroke-dasharray": _vm.dashArray,
      "stroke-dashoffset": _vm.dashOffset
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a1ec93d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/progress-circle/progress-circle.vue
// module id = 538
// module chunks = 9